// Place Categories and Tags Mapping
// This file contains the mapping for place categories and tags in different languages

const ENGLISH = "en"
const JAPANESE = "jp"
const TRADITIONAL_CHINESE = "tc"
const SIMPLIFIED_CHINESE = "sc"

export const PlaceCategoriesMapping = {
    // Wotagei Playing Locations
    PARK: {
        [ENGLISH]: "Park",
        [JAPANESE]: "公園",
        [TRADITIONAL_CHINESE]: "公園",
        [SIMPLIFIED_CHINESE]: "公园",
    },
    SPORTS_FACILITY: {
        [ENGLISH]: "Sports Facility",
        [JAPANESE]: "スポーツ施設",
        [TRADITIONAL_CHINESE]: "運動設施",
        [SIMPLIFIED_CHINESE]: "运动设施",
    },
    COMMUNITY_CENTER: {
        [ENGLISH]: "Community Center",
        [JAPANESE]: "コミュニティセンター",
        [TRADITIONAL_CHINESE]: "社區中心",
        [SIMPLIFIED_CHINESE]: "社区中心",
    },
    SHOPPING_CENTER: {
        [ENGLISH]: "Shopping Center",
        [JAPANESE]: "ショッピングセンター",
        [TRADITIONAL_CHINESE]: "購物中心",
        [SIMPLIFIED_CHINESE]: "购物中心",
    },
    ENTERTAINMENT: {
        [ENGLISH]: "Entertainment",
        [JAPANESE]: "エンターテイメント",
        [TRADITIONAL_CHINESE]: "娛樂場所",
        [SIMPLIFIED_CHINESE]: "娱乐场所",
    },
    KARAOKE: {
        [ENGLISH]: "Karaoke",
        [JAPANESE]: "カラオケ",
        [TRADITIONAL_CHINESE]: "卡拉OK",
        [SIMPLIFIED_CHINESE]: "卡拉OK",
    },
    ARCADE: {
        [ENGLISH]: "Arcade",
        [JAPANESE]: "ゲームセンター",
        [TRADITIONAL_CHINESE]: "電玩中心",
        [SIMPLIFIED_CHINESE]: "电玩中心",
    },
    LIVE_HOUSE: {
        [ENGLISH]: "Live House",
        [JAPANESE]: "ライブハウス",
        [TRADITIONAL_CHINESE]: "現場音樂廳",
        [SIMPLIFIED_CHINESE]: "现场音乐厅",
    },
    
    // Dining Locations
    RESTAURANT: {
        [ENGLISH]: "Restaurant",
        [JAPANESE]: "レストラン",
        [TRADITIONAL_CHINESE]: "餐廳",
        [SIMPLIFIED_CHINESE]: "餐厅",
    },
    CAFE: {
        [ENGLISH]: "Cafe",
        [JAPANESE]: "カフェ",
        [TRADITIONAL_CHINESE]: "咖啡廳",
        [SIMPLIFIED_CHINESE]: "咖啡厅",
    },
    RAMEN_SHOP: {
        [ENGLISH]: "Ramen Shop",
        [JAPANESE]: "ラーメン店",
        [TRADITIONAL_CHINESE]: "拉麵店",
        [SIMPLIFIED_CHINESE]: "拉面店",
    },
    FAST_FOOD: {
        [ENGLISH]: "Fast Food",
        [JAPANESE]: "ファストフード",
        [TRADITIONAL_CHINESE]: "快餐",
        [SIMPLIFIED_CHINESE]: "快餐",
    },
    CONVENIENCE_STORE: {
        [ENGLISH]: "Convenience Store",
        [JAPANESE]: "コンビニ",
        [TRADITIONAL_CHINESE]: "便利商店",
        [SIMPLIFIED_CHINESE]: "便利店",
    },
    
    // Other
    OTHER: {
        [ENGLISH]: "Other",
        [JAPANESE]: "その他",
        [TRADITIONAL_CHINESE]: "其他",
        [SIMPLIFIED_CHINESE]: "其他",
    },
}

export const PlaceTagsMapping = {
    // Popularity & Atmosphere
    POPULAR: {
        [ENGLISH]: "Popular",
        [JAPANESE]: "人気",
        [TRADITIONAL_CHINESE]: "熱門",
        [SIMPLIFIED_CHINESE]: "热门",
    },
    QUIET: {
        [ENGLISH]: "Quiet",
        [JAPANESE]: "静か",
        [TRADITIONAL_CHINESE]: "安靜",
        [SIMPLIFIED_CHINESE]: "安静",
    },
    FAMILY_FRIENDLY: {
        [ENGLISH]: "Family-friendly",
        [JAPANESE]: "家族向け",
        [TRADITIONAL_CHINESE]: "適合家庭",
        [SIMPLIFIED_CHINESE]: "适合家庭",
    },
    
    // Food & Drinks
    FOOD: {
        [ENGLISH]: "Food",
        [JAPANESE]: "食べ物",
        [TRADITIONAL_CHINESE]: "美食",
        [SIMPLIFIED_CHINESE]: "美食",
    },
    DRINKS: {
        [ENGLISH]: "Drinks",
        [JAPANESE]: "飲み物",
        [TRADITIONAL_CHINESE]: "飲品",
        [SIMPLIFIED_CHINESE]: "饮品",
    },
    LATE_NIGHT_FOOD: {
        [ENGLISH]: "Late Night Food",
        [JAPANESE]: "深夜営業",
        [TRADITIONAL_CHINESE]: "深夜營業",
        [SIMPLIFIED_CHINESE]: "深夜营业",
    },
    BUDGET_FRIENDLY: {
        [ENGLISH]: "Budget-friendly",
        [JAPANESE]: "お手頃価格",
        [TRADITIONAL_CHINESE]: "經濟實惠",
        [SIMPLIFIED_CHINESE]: "经济实惠",
    },
    
    // Location & Environment
    OUTDOOR: {
        [ENGLISH]: "Outdoor",
        [JAPANESE]: "屋外",
        [TRADITIONAL_CHINESE]: "戶外",
        [SIMPLIFIED_CHINESE]: "户外",
    },
    INDOOR: {
        [ENGLISH]: "Indoor",
        [JAPANESE]: "屋内",
        [TRADITIONAL_CHINESE]: "室內",
        [SIMPLIFIED_CHINESE]: "室内",
    },
    ACCESSIBLE: {
        [ENGLISH]: "Accessible",
        [JAPANESE]: "アクセシブル",
        [TRADITIONAL_CHINESE]: "無障礙",
        [SIMPLIFIED_CHINESE]: "无障碍",
    },
    PARKING: {
        [ENGLISH]: "Parking",
        [JAPANESE]: "駐車場",
        [TRADITIONAL_CHINESE]: "停車場",
        [SIMPLIFIED_CHINESE]: "停车场",
    },
    NEAR_STATION: {
        [ENGLISH]: "Near Station",
        [JAPANESE]: "駅近",
        [TRADITIONAL_CHINESE]: "近車站",
        [SIMPLIFIED_CHINESE]: "近车站",
    },
    
    // Amenities
    WIFI: {
        [ENGLISH]: "WiFi",
        [JAPANESE]: "WiFi",
        [TRADITIONAL_CHINESE]: "WiFi",
        [SIMPLIFIED_CHINESE]: "WiFi",
    },
    POWER_OUTLETS: {
        [ENGLISH]: "Power Outlets",
        [JAPANESE]: "電源コンセント",
        [TRADITIONAL_CHINESE]: "電源插座",
        [SIMPLIFIED_CHINESE]: "电源插座",
    },
    RESTROOM: {
        [ENGLISH]: "Restroom",
        [JAPANESE]: "トイレ",
        [TRADITIONAL_CHINESE]: "洗手間",
        [SIMPLIFIED_CHINESE]: "洗手间",
    },
    
    // Entertainment & Activities
    LIVE_MUSIC: {
        [ENGLISH]: "Live Music",
        [JAPANESE]: "ライブ音楽",
        [TRADITIONAL_CHINESE]: "現場音樂",
        [SIMPLIFIED_CHINESE]: "现场音乐",
    },
    GAMING: {
        [ENGLISH]: "Gaming",
        [JAPANESE]: "ゲーム",
        [TRADITIONAL_CHINESE]: "遊戲",
        [SIMPLIFIED_CHINESE]: "游戏",
    },
    KARAOKE: {
        [ENGLISH]: "Karaoke",
        [JAPANESE]: "カラオケ",
        [TRADITIONAL_CHINESE]: "卡拉OK",
        [SIMPLIFIED_CHINESE]: "卡拉OK",
    },
    BILLIARDS: {
        [ENGLISH]: "Billiards",
        [JAPANESE]: "ビリヤード",
        [TRADITIONAL_CHINESE]: "撞球",
        [SIMPLIFIED_CHINESE]: "撞球",
    },
    DANCE: {
        [ENGLISH]: "Dance",
        [JAPANESE]: "ダンス",
        [TRADITIONAL_CHINESE]: "舞蹈",
        [SIMPLIFIED_CHINESE]: "舞蹈",
    },
    
    // Wotagei Specific
    WOTAGEI_FRIENDLY: {
        [ENGLISH]: "Wotagei-friendly",
        [JAPANESE]: "ヲタ芸対応",
        [TRADITIONAL_CHINESE]: "御宅藝友善",
        [SIMPLIFIED_CHINESE]: "御宅艺友善",
    },
    SPACIOUS: {
        [ENGLISH]: "Spacious",
        [JAPANESE]: "広い",
        [TRADITIONAL_CHINESE]: "寬敞",
        [SIMPLIFIED_CHINESE]: "宽敞",
    },
    GOOD_ACOUSTICS: {
        [ENGLISH]: "Good Acoustics",
        [JAPANESE]: "音響良好",
        [TRADITIONAL_CHINESE]: "音響良好",
        [SIMPLIFIED_CHINESE]: "音响良好",
    },
    LIGHTING_CONTROL: {
        [ENGLISH]: "Lighting Control",
        [JAPANESE]: "照明調整可能",
        [TRADITIONAL_CHINESE]: "照明可調",
        [SIMPLIFIED_CHINESE]: "照明可调",
    },
}

// Tag number mapping for backend integration
export const PlaceTagNumbersMapping = {
    1: "POPULAR",
    2: "QUIET", 
    3: "FAMILY_FRIENDLY",
    4: "FOOD",
    5: "DRINKS",
    6: "OUTDOOR",
    7: "INDOOR",
    8: "ACCESSIBLE",
    9: "PARKING",
    10: "WIFI",
    11: "LIVE_MUSIC",
    12: "GAMING",
    13: "KARAOKE",
    14: "BILLIARDS",
    15: "DANCE",
    16: "LATE_NIGHT_FOOD",
    17: "BUDGET_FRIENDLY",
    18: "NEAR_STATION",
    19: "POWER_OUTLETS",
    20: "RESTROOM",
    21: "WOTAGEI_FRIENDLY",
    22: "SPACIOUS",
    23: "GOOD_ACOUSTICS",
    24: "LIGHTING_CONTROL"
}

// Helper function to get tag key from number
export const getTagKeyFromNumber = (tagNumber) => {
    return PlaceTagNumbersMapping[tagNumber] || null;
}

// Helper function to get tag display name from number and language
export const getTagDisplayName = (tagNumber, lang) => {
    const tagKey = getTagKeyFromNumber(tagNumber);
    if (tagKey && PlaceTagsMapping[tagKey]) {
        return PlaceTagsMapping[tagKey][lang] || tagKey;
    }
    return `Tag ${tagNumber}`;
} 